import { GlBadge, GlLoadingIcon, GlTooltipDirective, GlAvatarLink, GlAvatar } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isGid, getIdFromGraphQLId } from '~/graphql_shared/utils';
import { s__ } from '~/locale';
import ImportedBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/imported_badge.vue?vue3';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { withLinkedFileUrlParams } from '~/rapid_diffs/utils/linked_file';
import NoteAuthor from './note_author.vue';
export default {
    name: 'NoteHeader',
    components: {
        ImportedBadge,
        TimeAgoTooltip,
        GlBadge,
        GlLoadingIcon,
        GlAvatarLink,
        GlAvatar,
        NoteAuthor
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        filePaths: {
            default: null
        }
    },
    props: {
        showAvatar: {
            type: Boolean,
            required: false,
            default: true
        },
        author: {
            type: Object,
            required: false,
            default: null
        },
        createdAt: {
            type: String,
            required: false,
            default: null
        },
        noteId: {
            type: [
                String,
                Number
            ],
            required: false,
            default: null
        },
        isUpdating: {
            type: Boolean,
            required: false,
            default: false
        },
        isInternalNote: {
            type: Boolean,
            required: false,
            default: false
        },
        isImported: {
            type: Boolean,
            required: false,
            default: false
        },
        noteUrl: {
            type: String,
            required: false,
            default: undefined
        },
        hideUsername: {
            type: Boolean,
            required: false,
            default: false
        },
        singleLine: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        authorId () {
            return getIdFromGraphQLId(this.author.id);
        },
        resolvedNoteId () {
            if (!this.noteId) return null;
            let { noteId } = this;
            if (isGid(noteId)) noteId = getIdFromGraphQLId(noteId);
            return noteId;
        },
        noteFragment () {
            if (!this.resolvedNoteId) return null;
            return `note_${this.resolvedNoteId}`;
        },
        noteTimestampLink () {
            if (this.noteUrl) return this.noteUrl;
            if (!this.noteFragment) return undefined;
            if (this.filePaths) {
                return withLinkedFileUrlParams(window.location.href, {
                    oldPath: this.filePaths.oldPath,
                    newPath: this.filePaths.newPath,
                    hash: this.noteFragment
                }).toString();
            }
            return `#${this.noteFragment}`;
        },
        internalNoteTooltip () {
            return s__('Notes|This internal note will always remain confidential');
        }
    }
};
